import styles from "./buttom-bottom-section.module.css";

interface ButtonOption {
  text: string;
  onClick?: () => void;
  tabIndex?: number;
  className?: string;
  disabled?: boolean;
}

interface SubmitButtonOption extends ButtonOption {
  onSubmit?: (e: React.FormEvent) => void;
}

interface ButtonSectionProps {
  isProcessing?: boolean;
  cancelButton?: ButtonOption;
  submitButton?: SubmitButtonOption;
  confirmButton?: ButtonOption;
  style?: React.CSSProperties;
}

export default function ButtonSection({
  isProcessing = false,
  cancelButton,
  submitButton,
  confirmButton,
  style,
}: ButtonSectionProps) {
  // 폼 서브밋과 확인 버튼은 둘 중 하나만 사용 가능
  if (submitButton && confirmButton) {
    console.warn("ButtonSection: submitButton과 confirmButton은 동시에 사용할 수 없습니다.");
    return null;
  }

  return (
    <div className={styles.buttonGroup} style={style}>
      {/* 취소 버튼 */}
      {cancelButton && (
        <button
          type="button"
          className={`${styles.cancelButton} ${cancelButton.className || ""}`}
          onClick={cancelButton.onClick}
          tabIndex={cancelButton.tabIndex}
          disabled={cancelButton.disabled || isProcessing}
          style={{ "--hover-bg-color": "var(--color-warm-grey-90)" } as React.CSSProperties}
        >
          {cancelButton.text}
        </button>
      )}

      {/* 폼 서브밋 버튼 */}
      {submitButton && (
        <button
          type="submit"
          className={`${styles.submitButton} ${submitButton.className || ""}`}
          disabled={submitButton.disabled || isProcessing}
          tabIndex={submitButton.tabIndex}
          onClick={(e) => {
            if (submitButton.onSubmit) {
              e.preventDefault();
              submitButton.onSubmit(e);
            } else if (submitButton.onClick) {
              e.preventDefault();
              submitButton.onClick();
            }
          }}
          style={{ "--hover-bg-color": "var(--color-green-60)" } as React.CSSProperties}
        >
          {submitButton.text}
        </button>
      )}

      {/* 확인 버튼 */}
      {confirmButton && (
        <button
          type="button"
          className={`${styles.submitButton} ${confirmButton.className || ""}`}
          disabled={confirmButton.disabled || isProcessing}
          onClick={confirmButton.onClick}
          tabIndex={confirmButton.tabIndex}
          style={{ "--hover-bg-color": "var(--color-green-60)" } as React.CSSProperties}
        >
          {confirmButton.text}
        </button>
      )}
    </div>
  );
}
